(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("DoubleScrollbar", ["react"], factory);
	else if(typeof exports === 'object')
		exports["DoubleScrollbar"] = factory(require("react"));
	else
		root["DoubleScrollbar"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition